import { Component } from '@angular/core';
import {
  Page,
  TableViewAbstractComponent,
} from '../../ui/filterable-table/tableViewAbstractComponent';
import { UIHelpers } from '../../../core/ui-helpers';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { SearchFilters } from '../../../models/search/searchFilters';
import { TransactionFacade } from '../../../models/transactions/transactionFacade';
import { TransactionReportRecord } from '../../../models/transactions/transactionReportRecord';
import { ReportingService } from '../../../models/reporting/reportingService';

@Component({
  selector: 'app-transaction-report-table-view',
  templateUrl: './transaction-report-table-view.component.html',
  standalone: false,
})
export class TransactionReportTableViewComponent extends TableViewAbstractComponent {
  constructor(
    public reportingService: ReportingService,
    private uiErrorHandler: UIErrorHandler,
  ) {
    super();
  }

  getRecordFromDataSource(yyyy_mm: string): TransactionFacade {
    let yyyy = yyyy_mm.substring(0, 4);
    let mm = yyyy_mm.substring(5, 7);

    for (var i = 0; i < this.dataSource.data.length; i++) {
      if (
        this.dataSource.data[i].month == mm &&
        this.dataSource.data[i].year == yyyy
      ) {
        return this.dataSource.data[i];
      }
    }

    throw 'Transaction not found in dataset';
  }

  getPageOfData(
    query: string,
    filters: SearchFilters,
    pageNum: number,
    pageSize: number,
    sortColumn: string,
    sortDirection: string,
  ): Promise<Page<TransactionReportRecord>> {
    return this.reportingService
      .getPagedMonthlySummary({
        pageNum: pageNum,
        pageSize: pageSize,
        orderBy: 'name',
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        userId: this.options.userId ? this.options.userId : '',
        merchantId: this.options.merchantId ? this.options.merchantId : '',
        customerId: this.options.customerId ? this.options.customerId : '',
        sort: 'desc',
      })
      .then((response) => {
        response.records = response.records.splice(3);
        return response;
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
        return new Page<TransactionReportRecord>({});
      });
  }

  canQuery(): boolean {
    if (this.options) {
      return (
        (this.options && this.options.merchantId != undefined) ||
        this.options.customerId != undefined ||
        this.options.userId != undefined
      );
    }
    return false;
  }

  _selectRow_click(month: string, year: string) {
    this.selectRow_click(month + '_' + year);
    //if (this.options.selectAction != "none") {
    //this.selectRow_click(id);
    //}
  }

  formatDate(
    date: string | undefined,
    defaultText: string | undefined,
  ): string {
    if (date) {
      return UIHelpers.formatDate(date);
    } else {
      return defaultText + '';
    }
  }

  getMonthName(value: string): string {
    return UIHelpers.getMonthAbbrFromNumber(value);
  }

  getFormattedCurrency(value: number): string {
    return UIHelpers.formatCurrency(value);
  }
}
